import React from "react";
import { motion } from "framer-motion";

// Gold ornamental divider with a central diya glyph.
const Ornament = () => {
  return (
    <div className="relative z-10 flex items-center justify-center bg-[#0B0F19] py-14" data-testid="ornament-divider">
      <motion.div
        initial={{ opacity: 0, scaleX: 0.6 }}
        whileInView={{ opacity: 1, scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="flex w-full max-w-3xl items-center gap-4 px-6"
      >
        <span className="h-px flex-1 bg-gradient-to-r from-transparent to-[#D4AF37]/50" />
        <svg width="64" height="24" viewBox="0 0 64 24" fill="none" className="shrink-0">
          <circle cx="32" cy="12" r="4" fill="#D4AF37" />
          <path d="M32 3 L32 0 M32 24 L32 21 M23 12 L14 12 M50 12 L41 12" stroke="#D4AF37" strokeWidth="1.2" />
          <circle cx="9" cy="12" r="2" fill="#F3E5AB" />
          <circle cx="55" cy="12" r="2" fill="#F3E5AB" />
          <circle cx="32" cy="12" r="9" stroke="#D4AF37" strokeWidth="0.6" opacity="0.5" fill="none" />
        </svg>
        <span className="h-px flex-1 bg-gradient-to-l from-transparent to-[#D4AF37]/50" />
      </motion.div>
    </div>
  );
};

export default Ornament;
